var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3C3F4FF-9674-484A-81DF-B45D16E623D7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD10-1-Login-&-Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Create-Password",
    transform: "translate(-16.000000, -326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right",
    transform: "translate(16.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#969CA1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52352089,16.8763756 C9.44223378,16.9554335 9.33515357,16.9996005 9.22380112,17 C9.10600864,16.999492 8.99331283,16.9500263 8.91085841,16.8626396 L6.12963521,13.9780706 C6.01783154,13.8619284 5.97416723,13.6926476 6.01509021,13.5339944 C6.05601319,13.3753412 6.17530628,13.251419 6.32803292,13.208908 C6.48075957,13.1663971 6.64371696,13.2117558 6.75552062,13.3278979 L9.2326164,15.9056953 L17.2589357,8.12193775 C17.4378548,7.94998374 17.7170866,7.96125845 17.8826172,8.14712051 C18.0481479,8.33298257 18.0372944,8.62304981 17.8583752,8.79500384 L9.52352089,16.8763756 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTick);
export default __webpack_public_path__ + "static/media/grey_tick.258bf197bda34722e9e6e26eb9910f23.svg";
export { ForwardRef as ReactComponent };